<template>
  <ValidationProvider :customMessages="customMessages" v-slot="{ valid, classes, errors, ariaMsg, ariaInput }" :name="name" :rules="rules">
    <div class="validation">
      <label class="block text-gray-700 text-smaller font-bold" :for="name">
        {{ name }}<span class="ml-1 text-gray-500 font-normal" v-if="subLabel">{{subLabel}}</span>
      </label>
      <div class="flex justify-between items-end" :class="validationClasses(classes)">
        <div class="flex-1 relative">
          <span v-if="leftLogo" :style="leftLogoStyle" class="z-10 bg-contain bg-no-repeat bg-center w-6 h-6 absolute inset-y-0 left-0 ml-1"></span>
          <input :value="value" @input="$emit('input', $event.target.value)" :id="name" :class="{ nonEmpty: inputNonEmpty, 'pl-10': leftLogo }" class="text-input" :autocomplete="autocomplete" :type="type" :maxlength="maxlength" :placeholder="placeholder" v-bind="ariaInput">
          <svg class="validation absolute text-green-500 inset-y-0 right-0 mr-2 mt-2 fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24" style="-ms-transform:rotate(360deg);-webkit-transform:rotate(360deg)" transform="rotate(360)"><path d="M10 15.586l-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z" fill="currentColor"/><path fill="rgba(0, 0, 0, 0)" d="M0 0h24v24H0z"/></svg>
        </div>
        <slot :valid="valid"></slot>
      </div>
      <span v-bind="ariaMsg" class="text-error">{{ errors[0] || error }}</span>
    </div>
  </ValidationProvider>
</template>
<script>
  import { ValidationProvider } from 'vee-validate'

  export default {
    name: 'TextInput',
    components: {
      ValidationProvider
    },
    computed: {
      inputNonEmpty() {
        return this.value && this.value.length
      },
      leftLogoStyle() {
        return `background-image: url(${this.leftLogo}); margin-top: 8px;`;
      },
    },
    methods: {
      validationClasses(classes) {
        return this.validate ? classes : ''
      },
    },
    props: {
      value: {
        type: [String, Number],
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
      validate: {
        type: Boolean,
        default: true
      },
      rules: {
        type: [String, Object],
        default: ''
      },
      type: {
        type: String,
        default: 'text'
      },
      placeholder: {
        type: String,
        default: ''
      },
      maxlength: {
        type: Number,
        default: undefined,
      },
      autocomplete: {
        type: String,
        default: '',
      },
      customMessages: {
        type: Object,
        default: undefined,
      },
      error: {
        type: String,
        default: undefined
      },
      leftLogo: {
        type: String,
        default: undefined,
      },
      subLabel: {
        type: String,
        default: undefined
      },
      inputClass: {
        type: String,
        default: undefined
      }
    }
  }
</script>
<style lang="scss" scoped>
</style>
